import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { map, takeUntil, tap } from 'rxjs/operators';

import { MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { OutboxMessageNumbersService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { minNumberValidator } from 'src/app/core/validators/min-number-validator';
import { ConfirmDialogComponent } from 'src/app/shared/global/confirm-dialog/confirm-dialog.component';
import { DeliveryStatus } from '../../../../core/api/models/delivery-status';
import { SendTypes } from '../../../../core/api/models/send-types';
import { OutBoxMessagesService } from '../../../../core/api/services/out-box-messages.service';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import {
  CustomResultOfCheckIsResendByAutomaticResendDto,
  CustomResultOfGetResendCalculationDto,
  GetEnumValuesDto,
  GetResendCalculationQuery,
  OutboxMessageNumbersCountByDeliveryStatusDto,
  ResendByDeliveryStatusCommand,
  SmsCp,
  VoiceMessageDetailsRequest,
} from './../../../../core/api/models';
import { DeliveryStatusEnumDisplay } from './../../../../core/enums/display/delivery-status.display';
import {
  DialogService,
  DialogStatus,
  confirmDialogConfig,
} from './../../../../core/services/dialog.service';
import { AppDomService } from './../../../../core/services/dom.service';
import { DateTimeConfig } from './../../../../shared/components/date-time-picker/date-time-picker.component';
import { ResendCalculationComponent } from './../../../sending-system/resend-calculation/resend-calculation.component';

@Component({
  selector: 'app-resend-by-delivery-status',
  templateUrl: './resend-by-delivery-status.component.html',
  styleUrls: [
    './resend-by-delivery-status.component.scss',
    '../../../sending-system/base/base-sending-system.component.scss',
  ],
  standalone: false,
})
export class ResendByDeliveryStatusComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties

  @Input() model: ResendByDeliveryStatusCommand;
  @Input() sendType?: SendTypes;
  @Input() organizationId: number;
  @Input() userId: number;
  @Input() organizationName: string;
  @Input() userName: string;
  @Input() cpType: SmsCp;
  @Input() voiceMessageId: number;
  @Input() voiceMessageGroupId: number;
  @Input()
  deliveryStatusEnumValues: GetEnumValuesDto[];
  baseModel: ResendByDeliveryStatusCommand;
  voiceMessageDetail: VoiceMessageDetailsRequest = {};
  baseOrganizationId: number;
  baseUserId: any;

  smsBody;
  deliveryStatusData: OutboxMessageNumbersCountByDeliveryStatusDto[];

  public DeliveryStatusEnumDisplay: typeof DeliveryStatusEnumDisplay =
    DeliveryStatusEnumDisplay;

  directDateTimeConfig: DateTimeConfig;
  gradualDateTimeConfig: DateTimeConfig;

  isShowExtraReceivers: boolean = true;
  isShowSmsBody: boolean = true;
  isShowForP2pOrDynamicSendType = false;

  deliveryStatuses: number[] = [
    DeliveryStatus.HaveNotReceivedToPhone,
    DeliveryStatus.DidNotReceiveToItc,
    DeliveryStatus.NotSent,
  ];
  isCanSendVoice: boolean = false;

  get DeliveryStatus() {
    return DeliveryStatus;
  }

  selectedDeliveryStatus: number[];

  receiversNumbers: string;

  isShowDirectSend: boolean = true;
  isShowGradualSend: boolean = true;

  isExpandDirectDateTime: boolean = true;
  isExpandGradualDateTime: boolean = false;
  isSelectAllDeliveryStatus: boolean = false;
  //#endregion

  constructor(
    protected currentService: OutBoxMessagesService,
    public outboxMessageNumbersService: OutboxMessageNumbersService,
    private dialogService: DialogService
  ) {
    super();
  }

  ngOnInit() {
    try {
      if (this.organizationName)
        this.organizationName = decodeURIComponent(this.organizationName);
      if (this.userName) this.userName = decodeURIComponent(this.userName);
      if (
        this.sendType == SendTypes.P2P ||
        this.sendType == SendTypes.Dynamic ||
        this.sendType == SendTypes.ApiP2P
      ) {
        this.isShowForP2pOrDynamicSendType = true;
        this.isShowSmsBody = false;
        this.isShowExtraReceivers = false;
      }

      this.deliveryStatusApi();

      this.baseModel = Object.assign({}, this.model);
      this.initForm();
      this.pageVocabs = 'pages.outboxMessages.resendByDeliveryStatus.';

      this.setComponentsConfig();

      this.baseOrganizationId = this.organizationId;
      this.baseUserId = this.userId;

      this.model.isSendFromMyPanel = true;
      this.model.gradualChecked = false;
      this.changeIsSendFromMyPanel();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }

    this.smsBody = this.model.smsBody || '';
    this.isCanSendVoice = this.cpType == SmsCp.Avanak;
    if (this.isCanSendVoice)
      this.voiceMessageDetail.voiceMessageId = this.voiceMessageId;
    this.changeValidations(this.isCanSendVoice);
  }

  setComponentsConfig() {
    this.directDateTimeConfig = {
      dateLabel: 'common.sendDay',
      timeLabel: 'common.sendHour',
      dateFormControl: this.form?.get('sendDate') as FormControl,
      timeFormControl: this.form?.get('sendTime') as FormControl,
      responsiveClassName: 'md:tw-w-1/2',
      minDateType: 'today',
      isDefaultValue: true,
      isEditMode: this.formPageConfig.isEditMode,
    };

    this.gradualDateTimeConfig = {
      dateLabel: 'common.startDay',
      timeLabel: 'common.startHour',
      dateFormControl: this.form?.get('sendGradualDateStart') as FormControl,
      timeFormControl: this.form?.get('sendGradualTimeStart') as FormControl,
      minDateType: 'today',
      isDefaultValue: true,
      isEditMode: this.formPageConfig.isEditMode,
    };
  }

  initForm() {
    this.form = new FormGroup({
      smsBody: new FormControl('', [
        Validators.required,
        // Validators.pattern(RegularExpressions.smsBodyForbiddenCharacters),
      ]),
      senderNumberId: new FormControl('', Validators.required),
      voiceMessageId: new FormControl(''),
      voiceMessageGroupId: new FormControl(''),
      maxTryCount: new FormControl(''),
      minuteBetweenTries: new FormControl(''),
      extraReceivers: new FormControl(''),
      isSendFromMyPanel: new FormControl(''),
      isFlashSms: new FormControl(''),

      // direct send
      sendDate: new FormControl('', Validators.required),
      sendTime: new FormControl('', Validators.required),
      // gradualDateTime
      gradualChecked: new FormControl(''),
      gradualPeriodText: new FormControl(''),
      sendGradualDateStart: new FormControl(''),
      sendGradualTimeStart: new FormControl(''),
      gradualPageSize: new FormControl(''),
    });

    if (this.isShowForP2pOrDynamicSendType) {
      this.form.get('smsBody').clearValidators();
      this.form.get('smsBody').updateValueAndValidity();
    }
  }

  onReset() {
    this.model = Object.assign({}, this.baseModel);
  }

  //#region api
  ResendByDeliveryStatusApi() {
    this.unSubs();
    this.loading = true;

    this.currentService
      .outBoxMessagesResendByDeliveryStatusPost({ body: this.model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  ResendDynamicByDeliveryStatusApi() {
    this.unSubs();
    this.loading = true;

    this.currentService
      .outBoxMessagesResendDynamicByDeliveryStatusPost({
        body: {
          deliveryStatuses: this.model.deliveryStatuses,
          scheduledMessageId: this.model.scheduledMessageId,
          sendDateTime: this.model.sendDateTime,
          senderNumberId: this.model.senderNumberId,
          isSendFromMyPanel: this.model.isSendFromMyPanel,
          smsAggregators: this.model.smsAggregators,
        },
      })
      // isFlashSms: this.model.isCanSendFlashSms,
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  checkIsResendByAutomaticResendApi(
    scheduledMessageId
  ): Observable<CustomResultOfCheckIsResendByAutomaticResendDto> {
    return this.currentService
      .outBoxMessagesCheckIsResendByAutomaticResend({
        body: { scheduledMessageId: scheduledMessageId },
      })
      .pipe(this.basePipeOperators());
  }

  GetResendCalculationsApi(model: GetResendCalculationQuery) {
    this.unSubs();

    this.loading = true;
    this.currentService
      .outBoxMessagesGetResendCalculation({ body: model })
      .pipe(
        map((res: CustomResultOfGetResendCalculationDto) => {
          if (res.isSucceed) this.onConfirmation(res?.data);
        }),
        this.basePipeOperators()
      )
      .subscribe();
  }

  // DeliveryStatusChart
  deliveryStatusApi() {
    this.unSubs();
    this.loading = true;
    this.outboxMessageNumbersService
      .outboxMessageNumbersGetOutboxMessageDeliveryStatusStatisticsByScheduledMessageId(
        {
          body: { scheduledMessageId: this.model.scheduledMessageId },
        }
      )
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        try {
          if (res) {
            this.deliveryStatusData = res.data;
          }
        } catch (error) {
          this.loggerService.logError(
            this.tagName,
            error,
            EventTypes.smsReport
          );
        }
      });
  }

  //#endregion

  onConfirmation(model) {
    try {
      this.unSubs();
      let data = { model: model, sendType: this.sendType };

      const modalResult = this.dialogService.openModal({
        component: ResendCalculationComponent,
        data: data,
      });
      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((confirm) => {
          if (confirm) {
            this.checkIsResendByAutomaticResendApi(
              this.model.scheduledMessageId
            ).subscribe((apiResult) => {
              if (apiResult?.data?.isResent) {
                this.showConfirmDialog(apiResult).subscribe((dialogResult) => {
                  if (dialogResult) {
                    if (this.isShowForP2pOrDynamicSendType) {
                      this.ResendDynamicByDeliveryStatusApi();
                      return;
                    }
                    this.ResendByDeliveryStatusApi();
                  }
                });
              } else {
                if (this.isShowForP2pOrDynamicSendType) {
                  this.ResendDynamicByDeliveryStatusApi();
                  return;
                }
                this.ResendByDeliveryStatusApi();
              }
            });
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  isValidExtraReceiversCount(): boolean {
    try {
      if (!this.receiversNumbers) return true;

      if (this.receiversNumbers.split(',').length > 10) {
        this.dialogService.openDialog({
          title: 'common.error',
          message: this.pageVocabs + 'maxReceiversMsg',
          status: DialogStatus.error,
        });
        return false;
      }

      return true;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  onSubmit(): void {
    try {
      if (!this.isValidExtraReceiversCount()) return;

      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;

      if (!this.isSelectedDeliveryStatus()) return;

      this.model.extraReceivers = this.receiversNumbers;
      this.model.deliveryStatuses = this.selectedDeliveryStatus;

      this.GetResendCalculationsApi({
        deliveryStatusList: this.model.deliveryStatuses,
        isSendFromMyPanel: this.model.isSendFromMyPanel,
        privateNumberId: this.model.senderNumberId,
        scheduledMessageId: this.model.scheduledMessageId,
        smsBody: this.model.smsBody,
        operators: this.model.smsAggregators,
        receivers: this.compressionString(this.model.extraReceivers),
        voiceMessageDetails: this.model.voiceMessageDetails,
      });

      // if (this.isShowForP2pOrDynamicSendType) {
      //   this.ResendDynamicByDeliveryStatusApi();
      //   return;
      // }
      // this.ResendByDeliveryStatusApi();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  isSelectedDeliveryStatus(): boolean {
    let result: boolean = true;

    if (!this.selectedDeliveryStatus?.length) {
      result = false;
      this.dialogService.openDialog({
        title: 'common.error',
        message: this.pageVocabs + 'deliveryStatusRequiredMsg',
        status: DialogStatus.error,
      });
    }

    return result;
  }

  changeIsSendFromMyPanel() {
    if (this.model.isSendFromMyPanel) {
      this.organizationId = undefined;
      this.userId = undefined;
    } else {
      this.organizationId = this.baseOrganizationId;
      this.userId = this.baseUserId;
    }
  }

  showConfirmDialog(res) {
    const dialogResult = this.getConfirmDialog({
      title: 'messages.globalConfirmationMessage',
      isConfirmDelete: false,
      wordBreak: false,
      isWarning: true,
      confirmBtnColor: 'btn-warning',
      content: res.data.message,
    });
    return dialogResult.afterClosed().pipe(takeUntil(this.onDestroy$));
  }

  getConfirmDialog(
    config: confirmDialogConfig
  ): MatDialogRef<ConfirmDialogComponent, any> {
    try {
      return this.dialogService.confirmDialog(config);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.baseIndexPage
      );
    }
  }

  onLogForm() {
    this.cd.detectChanges();
  }

  changeValidations(isCanSendVoice) {
    if (isCanSendVoice) {
      this.form.get('voiceMessageId').setValidators([Validators.required]);
      // this.form.get('voiceMessageGroupId').setValidators([Validators.required]);
      this.form.get('maxTryCount').setValidators([Validators.required]);
      this.form.get('minuteBetweenTries').setValidators([Validators.required]);
      this.form.get('smsBody').clearValidators();
    } else {
      this.form.get('smsBody').setValidators([
        Validators.required,
        // Validators.pattern(RegularExpressions.smsBodyForbiddenCharacters),
      ]);
      this.form.get('voiceMessageId').clearValidators();
      this.form.get('voiceMessageGroupId').clearValidators();
      this.form.get('maxTryCount').clearValidators();
      this.form.get('minuteBetweenTries').clearValidators();
      if (this.isShowForP2pOrDynamicSendType) {
        this.form.get('smsBody').clearValidators();
      }
    }

    this.form.get('smsBody').updateValueAndValidity();
    this.form.get('voiceMessageId').updateValueAndValidity();
    this.form.get('voiceMessageGroupId').updateValueAndValidity();
    this.form.get('maxTryCount').updateValueAndValidity();
    this.form.get('minuteBetweenTries').updateValueAndValidity();
  }

  setSendTypeValidations(isGradual: boolean) {
    try {
      //clear
      this.clearSendTypeValidations();
      this.form.get('senderNumberId').setValidators(Validators.required);
      this.form.get('smsBody').setValidators([
        Validators.required,
        // Validators.pattern(RegularExpressions.smsBodyForbiddenCharacters),
      ]);
      //#region
      if (!isGradual) {
        this.form.get('sendDate').setValidators(Validators.required);
        this.form.get('sendTime').setValidators(Validators.required);
      } else if (isGradual) {
        this.form
          .get('gradualPeriodText')
          .setValidators([Validators.required, Validators.min(1)]);
        this.form
          .get('gradualPageSize')
          .setValidators([Validators.required, minNumberValidator(1000)]);
        this.form
          .get('sendGradualTimeStart')
          .setValidators(Validators.required);
        this.form
          .get('sendGradualDateStart')
          .setValidators(Validators.required);
      }
      //#endregion

      //update
      this.updateSendTypeValidations();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  clearSendTypeValidations() {
    try {
      Object.keys((<FormGroup>this.form).controls).forEach((key) => {
        this.form.get(key).clearValidators();
      });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  updateSendTypeValidations() {
    try {
      Object.keys((<FormGroup>this.form).controls).forEach((key) => {
        this.form.get(key).updateValueAndValidity();
      });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  onChangeGradualChecked(isGradual: boolean) {
    try {
      this.model.gradualChecked = isGradual;
      this.setSendTypeValidations(isGradual);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  selectAllDeliveryStatus() {
    if (this.isSelectAllDeliveryStatus) {
      this.selectedDeliveryStatus = this.deliveryStatusData.map(
        (item) => item.deliveryStatus
      );
    } else this.selectedDeliveryStatus = [];
  }
}
